import { render, staticRenderFns } from "./licDetail.vue?vue&type=template&id=338bcc02&scoped=true&"
import script from "./licDetail.vue?vue&type=script&lang=js&"
export * from "./licDetail.vue?vue&type=script&lang=js&"
import style0 from "./licDetail.vue?vue&type=style&index=0&id=338bcc02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338bcc02",
  null
  
)

export default component.exports